(function () {
    'use strict';

    if (document.readyState === 'interactive') {
        setup();
    } else {
        document.addEventListener('DOMContentLoaded', setup)
    }

    function loadComponent(componentName, Fn) {
        try {
            if (typeof (window.components) === 'undefined') window.components = {};
            window.components[componentName] = [];
            var elements = document.querySelectorAll('[data-ui-component="' + componentName + '"]');

            Array.prototype.forEach.apply(elements, [function (el) {
                window.components[componentName].push(new Fn(el));
            }]);
        } catch (err) {
            console.warn(err);
        }
        return;
    }

    function onDismissMessage(type, element, ID) {
        var data = {
            ID: ID,
            NotificationType: type,
            DateMarked: new Date().toISOString()
        }

        var headers = new Headers();
        headers.append('content-type', 'application/json');
        headers.append('accept', 'application/json');

        var init = {
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
            headers: headers
        }

        if (USER_ACTIONS && USER_ACTIONS.DISMISS_NOTIFICATION) {
            fetch(USER_ACTIONS.DISMISS_NOTIFICATION, init).then(function (response) {
                if (!response.ok) return Promise.reject(new Error(response.status + ' ' + response.statusText));
                return response.json()
            })
            .catch(function (reason) {
                /**
                * @todo Error handling (cookie? localStorage???)
                */
                console.warn(reason);
            })
        }

    }

    function setup() {       
        window.components = {};
        window.onDismissMessage = onDismissMessage;
        document.addEventListener('simple-carousel:ready', function (event) {
            window.setTimeout(function () {
                Array.prototype.forEach.apply(window.components['simple-carousel'], [function (c) {
                    if (c.items.length <= 1) {
                        c.setup({ buttons: false, autoplay: false })
                    } else {
                        c.container.addEventListener('mouseenter', function (event) {
                            c.pause();
                        })
                        c.container.addEventListener('mouseleave', function (event) {
                            c.play();
                        })
                    }
                }]);
            }, 0);
        });

        window.addEventListener('beforeunload', function (event) {
            var body = document.querySelector('body');

            body.classList.add('-loading');
        })

        var noLoader = document.querySelectorAll('[data-no-loader]');

        Array.prototype.forEach.apply(noLoader, [function (el) {
            el.addEventListener('click', function (event) {                         
                window.setTimeout(function () {
                    var body = document.querySelector('body');
                    body.classList.remove('-loading');                    
                }, 1);
            });
        }]);

        browserClass('arsv');
        objectFitImages();

        loadComponent('accordion-menu', AccordionMenu);
        loadComponent('ajax-search', AjaxSearch);
        loadComponent('alert-message', AlertMessage);
        loadComponent('category-manager', CategoryManager);
        loadComponent('category-manager-readonly', CategoryManagerReadOnly);
        loadComponent('color-picker', ColorPicker);
        loadComponent('detail-modal', DetailModal);
        loadComponent('favourite-button', FavouriteButton);
        loadComponent('file-upload', FileUpload);
        loadComponent('image-uploader', ImageUploader);
        loadComponent('rich-editor', RichEditor);
        loadComponent('mobile-menu', MobileMenu);
        loadComponent('mobile-submenu', MobileSubmenu);
        loadComponent('modal-window', ModalWindow);
        loadComponent('pagination-select', PaginationSelect);
        loadComponent('simple-carousel', SimpleCarousel);
        loadComponent('conditional-form', ConditionalForm);
        loadComponent('coward-form', CowardForm);
        loadComponent('upload-form', UploadForm);
        loadComponent('top-drawer', TopDrawer);
        loadComponent('lot-zoom', LotZoom);
        loadComponent('list-slider', ListSlider);

        gdprCookieNoticeSetup();

        /**
         * Paginazione AJAX 
         */
        window.loadMore = UpdateTable.loadMore;

        /**
         * Sticky Title
         */
        var STICKY_MIN_WIDTH = 1100;
        var sticky = document.querySelector('.stickyheading');
        var mainHeader = document.querySelector('.wrapper > header');
        var sideFilter = document.querySelector('.wrapper .arsv-search-filter');

        if (!sticky) {
            return;
        }

        var heading = sticky.querySelector(
            '.arsv-page-heading:not(.-small)'
        );

        var nextElement = sticky.nextElementSibling;

        if (!nextElement) {
            return;
        }

        var placeholder = document.createElement('div');
        var activationPoint = 0;
        var stickyHeight = 0;
        var shouldStick = false;
        var isStuck = false;

        placeholder.className = 'stickyheading-placeholder';
        placeholder.style.height = '0px';
        placeholder.style.visibility = 'hidden';
        placeholder.style.pointerEvents = 'none';

        sticky.parentNode.insertBefore(
            placeholder,
            mainHeader
        );

        function calculatePositions() {
            if (window.innerWidth <= STICKY_MIN_WIDTH) {
                shouldStick = false;
                return;
            }

            var stickyRect = sticky.getBoundingClientRect();
            var originalBottom = stickyRect.bottom;

            stickyHeight = sticky.offsetHeight;

            if (sideFilter) {
                sideFilter.style.top = stickyHeight + 102 + 'px';
            }

            activationPoint =
                window.pageYOffset +
                stickyRect.bottom;

            var threshold = heading
                ? nextElement.clientHeight
                : nextElement.clientHeight + originalBottom;

            shouldStick = threshold > window.innerHeight;
        }

        function activateSticky() {
            if (isStuck) {
                return;
            }

            /*
             * Il placeholder deve ricevere l'altezza prima che
             * lo sticky diventi fixed e venga rimosso dal flusso.
             */
            placeholder.style.height = stickyHeight + 'px';
            
            sticky.classList.add('-stick-top');

            if (heading) {
                heading.classList.add('-small');
                if (sideFilter) {
                    sideFilter.style.top = heading.offsetHeight + 102 + 'px';
                }
            }

            

            var openInside = sticky.querySelector('.-open');

            if (openInside) {
                openInside.classList.remove('-open');
            }

            isStuck = true;
        }

        function deactivateSticky() {
            if (!isStuck) {
                return;
            }

            sticky.classList.remove('-stick-top');

            if (heading) {
                heading.classList.remove('-small');

                if (sideFilter) {
                    sideFilter.style.top =
                        window.matchMedia('(min-width: 1100px)').matches > STICKY_MIN_WIDTH
                            ? stickyHeight + 102 + 'px'
                            : '';
                }
            }

            placeholder.style.height = '0px';

            isStuck = false;
        }

        function updateSticky() {
            if (!shouldStick) {
                deactivateSticky();
                return;
            }

            if (window.pageYOffset > activationPoint) {
                activateSticky();
            } else {
                deactivateSticky();
            }
        }

        function recalculateSticky() {
            /*
             * Per ricalcolare correttamente la posizione originale,
             * lo sticky deve prima tornare nel flusso del documento.
             */
            deactivateSticky();
            calculatePositions();
            updateSticky();
        }

        calculatePositions();
        updateSticky();

        window.addEventListener(
            'scroll',
            updateSticky,
            { passive: true }
        );

        window.addEventListener(
            'resize',
            recalculateSticky
        );


    }


    /* 
     * Modale informativa accessibile (WCAG 2.2)
     *  */
    

    //var COOKIE_NAME = 'clubArsValuePopupSeen';
    var SHOW_DELAY = 7500; // 7.5 secondi 10 secondi

    var modal = document.getElementById('infoModal');
    if (!modal) return;

    var popupCode = modal.getAttribute('data-popup-code') || 'Default';
    
    var COOKIE_NAME = 'clubArsValuePopupSeen_' + encodeURIComponent(popupCode);

    var dialog = modal.querySelector('.c-modal__dialog');
    var lastFocused = null; // elemento a cui restituire il focus alla chiusura
    var timerId = null;

    /* ---- Cookie di sessione -------------------------------------
        * Senza attributo Expires/Max-Age il cookie è "di sessione":
        * il browser lo elimina alla chiusura.
        */
    function hasSeenCookie() {
        return document.cookie
            .split('; ')
            .some(function (row) { return row.indexOf(COOKIE_NAME + '=') === 0; });
    }

    function setSessionCookie() {
        document.cookie = COOKIE_NAME + '=1; path=/; SameSite=Lax';
    }

    /* ---- Focus trap --------------------------------------------- */
    var FOCUSABLE = [
        'a[href]',
        'button:not([disabled])',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[tabindex]:not([tabindex="-1"])'
    ].join(',');

    function getFocusable() {
        return Array.prototype.slice
            .call(dialog.querySelectorAll(FOCUSABLE))
            .filter(function (el) {
                return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
            });
    }

    function onKeydown(e) {
        if (e.key === 'Escape') {
            e.preventDefault();
            closeModal();
            return;
        }

        if (e.key !== 'Tab') return;

        var items = getFocusable();
        if (items.length === 0) {
            e.preventDefault();
            return;
        }

        var first = items[0];
        var last = items[items.length - 1];

        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    }

    /* ---- Apertura / chiusura ------------------------------------ */
    function openModal() {
        lastFocused = document.activeElement;

        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden'; // blocca scroll di sfondo

        var focusables = getFocusable();
        (focusables[0] || dialog).focus();

        document.addEventListener('keydown', onKeydown, true);
    }

    function closeModal() {
        if (modal.hidden) return;

        modal.hidden = true;
        document.documentElement.style.overflow = '';
        document.removeEventListener('keydown', onKeydown, true);

        setSessionCookie(); // non ricomparirà fino alla chiusura del browser

        // Restituzione del focus all'elemento precedente (2.4.3)
        if (lastFocused && typeof lastFocused.focus === 'function') {
            lastFocused.focus();
        }
    }

    /* ---- Event binding ------------------------------------------ */
    modal.addEventListener('click', function (e) {

        var link = e.target.closest('[data-modal-link]');

        if (link) {            
            setSessionCookie();
            return;
        }

        if (e.target.closest('[data-modal-close]')) {
            closeModal();
        }
    });

    /* ---- Avvio timer -------------------------------------------- */
    if (!hasSeenCookie()) {
        timerId = window.setTimeout(openModal, SHOW_DELAY);
    }

    // Sicurezza: annulla il timer se l'utente lascia la pagina prima dei 10s
    window.addEventListener('pagehide', function () {
        if (timerId) window.clearTimeout(timerId);
    });



})();


